import { SourceWeightsArray } from "./SourceWeightsArray";
import type { Static } from "runtypes";

export const SourceWeightsType = SourceWeightsArray;
export type SourceWeightsType = Static<typeof SourceWeightsType>;
